/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedDescription_buyPage$ref = any;
export type BuySharedDescription_buyPage = {
    readonly description: string | null;
    readonly " $refType": BuySharedDescription_buyPage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedDescription_buyPage",
    "type": "BuyPageConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'dc12226b57f685da0a8cec14853474a1';
export default node;
